import {formatUsStateLabel} from "@/src/modules/core/lib/us-state-options";

import type {Vehicle} from "../types";

function normalizeVehicleField(value: string | undefined | null): string {
  const normalized = value?.trim() ?? "";
  return normalized === "-" || normalized === "—" ? "" : normalized;
}

/** Make · Model · Color · State — omit empty segments. */
export function formatVehicleMakeModelColorState(
  vehicle:
    | Pick<Vehicle, "make" | "model" | "color" | "state">
    | Partial<Pick<Vehicle, "make" | "model" | "color" | "state">>
    | null
    | undefined,
): string | null {
  if (!vehicle) return null;

  const parts = [
    normalizeVehicleField(vehicle.make),
    normalizeVehicleField(vehicle.model),
    normalizeVehicleField(vehicle.color),
    vehicle.state?.trim() ? formatUsStateLabel(vehicle.state) : "",
  ].filter((value) => value.length > 0);

  return parts.length > 0 ? parts.join(" · ") : null;
}
